export const HEADER_CONTENT = [
  {
    title: 'you are the media now',
    subtitle: "Let your voice be heard",
    anchor: "Buy $media",
    href: "https://dexscreener.com/solana/5e4pdnmb1wqwkzzvr3o3fvhwnbscffaivexq3capygkq"
  }
];
